import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import PostListPage from '../components/PostListing/PostListPage'
import Layout from '../layout'
import config from '../../data/SiteConfig'
import '../components/Blog/Blog.scss'
import Hero from '../components/Category/Hero'
import HeroImage from '../components/Category/HeroImage'
import CategoryNavigation from '../components/CategoryNavigation'
import { Link } from 'gatsby'

export default class CategoryTemplate extends React.Component {
  render() {
    const { category } = this.props.pageContext
    const postEdges = this.props.data.allMarkdownRemark.edges
    const categoryList = this.props.data.allCategories.distinct
    return (
      <Layout
        location={this.props.location}
        title={category.charAt(0).toUpperCase() + category.slice(1)}
        hero={<Hero category={category} />}
        heroType=""
        heroImage={<HeroImage />}
      >
        <div className="blog-container category-container">
          <div className="categories-container">
            <CategoryNavigation
              label="Categories"
              dropdownItems={categoryList}
            />
            <Link to="/blog">View all posts</Link>
          </div>
          <h3 className="category-identifier">
            Posts in <i className="slim-serif capitalize">{category}</i>{' '}
            category
          </h3>
          <Helmet>
            <title>
              {config.metaTags.blogCategory}{' '}
              {category.charAt(0).toUpperCase() + category.slice(1)} |{' '}
              {config.siteTitle}
            </title>
            <link
              rel="canonical"
              href={`${config.siteUrl}/categories/${category}`}
            />
          </Helmet>
          <PostListPage postEdges={postEdges} />
        </div>
      </Layout>
    )
  }
}

export const pageQuery = graphql`
  query CategoryPage($category: String) {
    allMarkdownRemark(
      limit: 1000
      sort: {fields: {date: DESC}}
      filter: {
        frontmatter: { category: { eq: $category } }
        fields: {slug: {regex: "/blog|video/"}}
      }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            author {
              full_name
            }
            tags
            layout
            length
            category
            assets {
              hero
            }
            nutgraf
            date
          }
        }
      }
    }
    allCategories: allMarkdownRemark {
      distinct(field: frontmatter___category)
    }
  }
`
